import superagent from 'superagent';

const DATA_URL = 'https://www.mp-plus.com/wp-admin/admin-ajax.php';

const getData = (cb)=>{
	superagent
	.get(DATA_URL)
	.query({action: 'get_cal_events'})
	.end((err, data)=>{
		if (err || !data || data.hasOwnProperty('body') === false || data.body.hasOwnProperty('events') === false) {
			cb('[SSD Events Calendar] Cannot reach the server or data integrity problem: ' + err, null);
		} else {
			cb(null, data.body.events)
		}
	});
};

export {getData};



/** WEBPACK FOOTER **
 ** ./src/components/store/index.js
 **/